import Logger from '../../logger';

import { AUTH_DISCONNECTED, EPISODE_LOADED, EPISODE_LOADING, SHOW_NOT_FOUND } from '../mutation-types';
import { EPISODE_LOAD } from '../actions';
import each from 'lodash/each';
import without from 'lodash/without';

import Crud, { EPISODES } from '../../api/crud';

const api = (function _detectAPI() {
   // if (process.env.NODE_ENV !== 'production') {
   //    const Mock = require('../../mocks/episodes').default;
   //    return new Mock();
   // }
   return new Crud(EPISODES);
})();

const logger = new Logger('Episodes');

const DEFAULT_STATE = {
   list: [],
   loadingList: []
};

const getters = {
   getLoadingEpisodeIds: state => state.loadingList,
   getLoadedEpisod: state => state.list
};

const actions = {
   async [EPISODE_LOAD]({ commit, state }, id) {
      commit(EPISODE_LOADING, id);
      try {
         const episode = await api.get(id);
         commit(EPISODE_LOADED, episode);
         return episode;
      } catch(e) {
         logger.error(e);
         commit(SHOW_NOT_FOUND, e.reason);
         return null;
      }
   }
};

const mutations = {
   [EPISODE_LOADING](state, id) {
      state.loadingList.push(id);
   },
   [EPISODE_LOADED](state, episod) {
      state.list.push(episod);
      state.loadingList = without(state.loadingList, episod.id);
   },

   [AUTH_DISCONNECTED](state) {
      each(DEFAULT_STATE, ( val, key ) => {
         state[key] = val;
      });
   }
};

export default {
   state: { ...DEFAULT_STATE },
   getters,
   actions,
   mutations
};
